import { EditorUtils } from "@progress/kendo-react-editor";

const { sanitizeClassAttr, sanitizeStyleAttr, removeAttribute } = EditorUtils;

// Main paste settings object for Kendo Editor
export const pasteSettings = {
  stripTags: "h1|h2|h3|h4|h5|h6|code|font", // Remove unwanted tags
  attributes: {
    class: sanitizeClassAttr,
    style: sanitizeStyleAttr,
    width: () => {}, // Keep width
    height: () => {}, // Keep height
    src: () => {}, // Keep image sources
    // style: removeAttribute,
  },
};

export const contentStyleSettings = (taskKey) => {
  return taskKey !== "Dox" ? { fontSize: "16px", fontFamily: "Roboto, sans-serif" } : {};
};
